import { render } from "./DeleteRequestDialog.vue?vue&type=template&id=425bf2cb"
import script from "./DeleteRequestDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRequestDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__